import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';
import { getSettings, saveSettings } from '../utils/storage';

const { FiSave, FiBriefcase, FiHash, FiUser, FiPhone } = FiIcons;

export default function Settings() {
  const [settings, setSettings] = useState(getSettings());
  const [saved, setSaved] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    saveSettings(settings);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-slate-900">Einstellungen</h2>
        <p className="text-slate-500">Konfiguration der Weativ GmbH Firmendaten</p>
      </div>

      <form onSubmit={handleSave} className="space-y-6">
        <div className="bg-white p-6 rounded-2xl ring-1 ring-slate-200 shadow-sm space-y-4">
          <h3 className="font-bold text-lg flex items-center gap-2">
            <SafeIcon icon={FiBriefcase} /> Firmendaten & Geschäftsführung
          </h3>
          <div className="grid gap-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Firmenname</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.companyName}
                  onChange={e => setSettings({...settings, companyName: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1 flex items-center gap-1">
                   Geschäftsführer
                </label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.ceo}
                  onChange={e => setSettings({...settings, ceo: e.target.value})}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Anschrift</label>
              <textarea
                rows="2"
                className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                value={settings.address}
                onChange={e => setSettings({...settings, address: e.target.value})}
              />
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Telefon</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.phone}
                  onChange={e => setSettings({...settings, phone: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">E-Mail</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.email}
                  onChange={e => setSettings({...settings, email: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">USt-ID</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.taxId}
                  onChange={e => setSettings({...settings, taxId: e.target.value})}
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4 border-t pt-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Registergericht</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.register}
                  onChange={e => setSettings({...settings, register: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Handelsregisternummer</label>
                <input
                  className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                  value={settings.hrb}
                  onChange={e => setSettings({...settings, hrb: e.target.value})}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl ring-1 ring-slate-200 shadow-sm space-y-4">
          <h3 className="font-bold text-lg flex items-center gap-2">
            <SafeIcon icon={FiHash} /> Nummerierung
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Präfix</label>
              <input
                className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                value={settings.prefix}
                onChange={e => setSettings({...settings, prefix: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Nächste Nummer</label>
              <input
                type="number"
                className="w-full px-4 py-2 rounded-lg ring-1 ring-slate-200 focus:ring-2 focus:ring-blue-500 outline-none"
                value={settings.nextNumber}
                onChange={e => setSettings({...settings, nextNumber: e.target.value})}
              />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          {saved && <span className="text-green-600 font-medium">Änderungen gespeichert!</span>}
          <button
            type="submit"
            className="bg-slate-900 text-white px-8 py-3 rounded-xl font-semibold hover:bg-slate-800 transition-all shadow-lg flex items-center gap-2 ml-auto"
          >
            <SafeIcon icon={FiSave} /> Einstellungen speichern
          </button>
        </div>
      </form>
    </div>
  );
}